import { Component, Input } from '@angular/core';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-app-card1',
  templateUrl: './app-card1.component.html',
  styleUrls: ['./app-card1.component.scss'],
  standalone: false
})
export class AppCard1Component {
  image: any
  @Input() isSelected: boolean = false;

  constructor(
    private imageService: ServicesService
  ) { }

  ngOnInit() {
    this.imageService.image$.subscribe((image) => {
      this.image = 'https://aieventzo.com/upload/event_image/' + image;
    });

  }

  defaultImage: string = 'https://aieventzo.com/upload/event_logo/66a0e18c3d4d9.png'; // Fallback image URL

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.defaultImage; // Set the fallback image URL
  }
}
